import React, { Suspense } from "react";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router";
import { Provider } from "react-redux";
import store from "./store/index.js";
import { mainTheme } from "@cambridgeassessment/cambridge-ui";
import {
  ThemeProvider,
  CssBaseline,
  StyledEngineProvider,
} from "@mui/material";
import { createRoot } from "react-dom/client";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import oktaOidcConfigDetails from "./util/oktaConfig.js";
import CircularWithValueLabel from "./components/spinner.js";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
const oktaAuth = new OktaAuth(oktaOidcConfigDetails);

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  window.history.redirectUri(toRelativeUrl(originalUri || '/', window.location.origin));
};
const App = React.lazy(() => import('./App'));
root.render(
  <Provider store={store}>
    <Suspense
      fallback={<CircularWithValueLabel />}
    >
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={mainTheme}>
            <CssBaseline />
            <Security
              oktaAuth={oktaAuth}
              restoreOriginalUri={restoreOriginalUri}
            >
              <App />
            </Security>
          </ThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </Suspense>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: 
reportWebVitals();